/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */
import * as consts from '../../../const';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Button, SelectDropdown } from 'tc-client-common';
import ReportsService from './reports.service';
import Loading from '../../loading/loading.component';
import Notification from '../../common/notification/notification.component';

class ParticipantArchiveModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedParticipant: null,
      disabled: true
    };
    this.goToNextStep = this.goToNextStep.bind(this);
    this.selectParticipant = this.selectParticipant.bind(this);
  }

  selectParticipant(participant) {
    this.setState({ selectedParticipant: participant, disabled: false });
  }

  goToNextStep() {
    this.props.goNext(this.props.study);
  }

  render() {
    const participantsElems = [{ label: 'All participants', value: 'ALL' }];
    const defaultValue = { label: 'Select participants', value: '' };
    const selectedParticipant = this.state.selectedParticipant;
    return (
      <div>
        <div id="reports-modal">
          <div id="reports-modal-body">
            <SelectDropdown
              id="participant-archives"
              options={participantsElems}
              selectedValue={selectedParticipant ? selectedParticipant : defaultValue}
              onChange={this.selectParticipant}
            />
          </div>
          <div id="reports-modal-footer">
            <hr className="reports-modal-divider" />
            <Button
              id="close-raports-popup"
              theme="default large-button"
              handleClick={this.props.close}
              label={consts.CLOSE}
            />
            <Button
              id="export-raports-popup"
              theme="active large-button"
              handleClick={this.goToNextStep}
              label={consts.NEXT}
              disabled={this.state.disabled}
            />
          </div>
        </div>
      </div>
    );
  }
}

ParticipantArchiveModal.propTypes = {
  close: PropTypes.func
};

export default ParticipantArchiveModal;
